import { useLocation } from 'react-router-dom';
import BottomBar from './BottomBar';

const Layout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/home';
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <div className="max-w-md mx-auto bg-white min-h-screen flex flex-col">
        <main className={`pb-20 flex-1 relative ${isHomePage ? 'flex flex-col overflow-hidden' : ''}`}>
          {children}
        </main>
        <BottomBar />
      </div>
    </div>
  );
};

export default Layout;

